import {
  Box,
  Button,
  Card,
  Dialog,
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Checkbox,
  Typography,
  Stack,
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';
import HighlightOffOutlinedIcon from '@mui/icons-material/HighlightOffOutlined';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import AppRegistrationIcon from '@mui/icons-material/AppRegistration';
import SlowMotionVideoIcon from '@mui/icons-material/SlowMotionVideo';
import HomeIcon from '@mui/icons-material/Home';
import toast from 'react-hot-toast';
import ImageIcon from '@mui/icons-material/Image';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import { useTranslation } from 'react-i18next';
import { shallowEqual, useSelector, useDispatch } from 'react-redux';
import Folder from '../../../components/selectfilesmodal/Folder';
import { useEffect, useState } from 'react';
import { getContent } from 'src/redux/actions/Content';
import { resolveSrc } from '../../../api/endpoints';
import { changeFolder } from 'src/redux/actions/FileFolder';
import SelectFilesModalFolder from './SelectFilesModalFolder';
import { getNiceTimestamp } from 'src/utils/get-nice-timestamp';
import { splitYoutubePending } from 'src/utils/youtubeProcessing';
import YoutubeProcessingDialog from 'src/components/selectfilesmodal/YoutubeProcessingDialog';

const SelectFilesModalScheduler = ({
  open,
  setOpenSelectFiles,
  onSaveFiles,
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const { contentFolders } = useSelector(
    (state) => ({
      contentFolders: state.FileFolder.userFolders.filter(
        (f) => f?.folderFor === 'content',
      ),
    }),
    shallowEqual,
  );
  const { content, contentsCount } = useSelector((state) => state.Content);

  const [sortOption, setSortOption] = useState('asc');
  const [selectFilesQuery, setSelectFilesQuery] = useState({
    name: '',
    type: '',
    page: 0,
    sortType: 'createdAt',
    sortDirection: -1,
    folder: '',
    origin: '',
  });
  const [selectedFile, setSelectedFile] = useState({ id: '', name: '' });
  const [ytPendingNames, setYtPendingNames] = useState([]);

  const handleClose = () => {
    setOpenSelectFiles(false);
    setSelectedFile({ id: '', name: '' });
  };

  useEffect(() => {
    switch (sortOption) {
      case 'asc':
        setSelectFilesQuery({
          ...selectFilesQuery,
          sortType: 'createdAt',
          sortDirection: -1,
          origin: 'sort',
        });
        break;
      case 'desc':
        setSelectFilesQuery({
          ...selectFilesQuery,
          sortType: 'createdAt',
          sortDirection: 1,
          origin: 'sort',
        });
        break;
      case 'name_desc':
        setSelectFilesQuery({
          ...selectFilesQuery,
          sortType: 'name',
          sortDirection: 1,
          origin: 'sort',
        });
        break;
      case 'name_asc':
        setSelectFilesQuery({
          ...selectFilesQuery,
          sortType: 'name',
          sortDirection: -1,
          origin: 'sort',
        });
        break;
      default:
        setSelectFilesQuery({
          ...selectFilesQuery,
          sortType: 'createdAt',
          sortDirection: 1,
          origin: 'sort',
        });
        break;
    }
  }, [sortOption]);

  useEffect(() => {
    // console.log(selectFilesQuery.origin)
    dispatch(
      getContent(
        selectFilesQuery.page,
        selectFilesQuery.name,
        selectFilesQuery.sortType,
        selectFilesQuery.sortDirection,
        selectFilesQuery.type,
        selectFilesQuery.folder == 'root' ? '' : selectFilesQuery.folder,
      ),
    );
  }, [selectFilesQuery]);

  const handleSave = () => {
    if (selectedFile.id) {
      const { pending } = splitYoutubePending(
        [content.find((c) => c.id == selectedFile.id)],
        { isScreenTarget: true },
      );
      if (pending.length > 0) {
        setYtPendingNames(pending.map((file) => file.name));
        return;
      }
      console.log(content.find((c) => c.id == selectedFile.id));
      onSaveFiles(content.find((c) => c.id == selectedFile.id));
      setOpenSelectFiles(false);
      setSelectedFile({ id: '', name: '' });
    } else {
      toast.error(t('views.selectFilesModal.selectFileErr'));
    }
  };

  return (
    <>
      <Dialog open={open} onClose={handleClose} fullWidth maxWidth={'xl'}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: '15px',
            p: 3,
          }}
        >
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <IconButton onClick={handleClose}>
              <CloseIcon />
            </IconButton>
            <Button variant='contained' onClick={handleSave}>
              {t('views.selectFilesModal.add')}
            </Button>
          </Box>
          {selectFilesQuery.folder ? (
            <Box
              sx={{
                display: 'flex',
                gap: '5px',
                alignItems: 'center',
              }}
            >
              <IconButton
                onClick={() => {
                  setSelectFilesQuery({
                    ...selectFilesQuery,
                    folder: '',
                    page: 0,
                    origin: 'page',
                  });
                  dispatch(changeFolder('root'));
                }}
              >
                <HomeIcon color='primary' />
              </IconButton>
              <Typography variant='button'>
                {
                  contentFolders.find((f) => f._id == selectFilesQuery.folder)
                    ?.name
                }
              </Typography>
            </Box>
          ) : null}
          <Box
            sx={{
              display: 'flex',
              gap: '20px',
            }}
          >
            {contentFolders
              .filter((fl) =>
                selectFilesQuery.folder
                  ? fl.parent == selectFilesQuery.folder
                  : fl.parent == 'root',
              )
              .map((f) => {
                return (
                  <SelectFilesModalFolder
                    folder={f}
                    setSelectFilesQuery={setSelectFilesQuery}
                    selectFilesQuery={selectFilesQuery}
                  />
                );
              })}
          </Box>
          <Card
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              gap: '10px',
              p: 2,
              backgroundColor: '#131b2a',
              flexWrap: 'wrap',
            }}
          >
            <Box
              sx={{
                width: '70%',
              }}
              component='form'
              onSubmit={(e) => {
                e.preventDefault();
                setSelectFilesQuery({
                  ...selectFilesQuery,
                  name: e.target[0].value,
                  page: 0,
                  origin: 'name',
                });
              }}
              onReset={() =>
                setSelectFilesQuery({
                  ...selectFilesQuery,
                  name: '',
                  origin: 'name',
                })
              }
            >
              <OutlinedInput
                sx={{
                  minWidth: '200px',
                  width: '100%',
                  maxWidth: '400px',
                }}
                startAdornment={
                  <InputAdornment position='start'>
                    <SearchIcon color='disabled' />
                  </InputAdornment>
                }
                placeholder={t('components.redesignBodyHeader.search')}
                id='searchByNameInput'
              />
              <IconButton type='submit'>
                <SearchIcon color='primary' />
              </IconButton>
              {selectFilesQuery.name ? (
                <IconButton type='reset'>
                  <CloseIcon color='error' />
                </IconButton>
              ) : null}
            </Box>
            <FormControl
              sx={{
                width: '200px',
              }}
            >
              <InputLabel id='sortOptions'>
                {t('components.redesignBodyHeader.sortBy')}
              </InputLabel>
              <Select
                labelId='sortOptions'
                id='sortOptionsSelect'
                value={sortOption}
                label={t('components.redesignBodyHeader.sortBy')}
                onChange={(e) => setSortOption(e.target.value)}
              >
                <MenuItem value={'desc'}>
                  ↓ {t('components.redesignBodyHeader.createDate')}
                </MenuItem>
                <MenuItem value={'asc'}>
                  ↑ {t('components.redesignBodyHeader.createDate')}
                </MenuItem>
                <MenuItem value={'name_desc'}>
                  ↓ {t('components.redesignBodyHeader.name')}
                </MenuItem>
                <MenuItem value={'name_asc'}>
                  ↑ {t('components.redesignBodyHeader.name')}
                </MenuItem>
              </Select>
            </FormControl>
          </Card>
          <Box
            sx={{
              display: 'flex',
              gap: '10px',
            }}
          >
            <Button
              onClick={() =>
                setSelectFilesQuery({
                  ...selectFilesQuery,
                  type: '',
                  origin: 'type',
                })
              }
              startIcon={<FileCopyIcon />}
            >
              {t('views.redesignFile.all')}
            </Button>
            <Button
              onClick={() =>
                setSelectFilesQuery({
                  ...selectFilesQuery,
                  type: 'images',
                  origin: 'type',
                })
              }
              startIcon={<ImageIcon />}
            >
              {t('views.redesignFile.images')}
            </Button>
            <Button
              onClick={() =>
                setSelectFilesQuery({
                  ...selectFilesQuery,
                  type: 'videos',
                  origin: 'type',
                })
              }
              startIcon={<SlowMotionVideoIcon />}
            >
              {t('views.redesignFile.videos')}
            </Button>
            <Button
              onClick={() =>
                setSelectFilesQuery({
                  ...selectFilesQuery,
                  type: 'apps',
                  origin: 'type',
                })
              }
              startIcon={<AppRegistrationIcon />}
            >
              {t('views.redesignFile.apps')}
            </Button>
          </Box>
          <Box
            sx={{
              display: 'flex',
              flexWrap: 'wrap',
              gap: '10px',
            }}
          >
            {selectedFile.id ? (
              <Button
                size='small'
                color='secondary'
                startIcon={<HighlightOffOutlinedIcon />}
                onClick={() => setSelectedFile({ id: '', name: '' })}
              >
                {selectedFile.name.length > 15
                  ? `${selectedFile.name.slice(0, 15)}...`
                  : selectedFile.name}
              </Button>
            ) : null}
          </Box>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>#</TableCell>
                  <TableCell align='left'>
                    {t('views.selectFilesModal.preview')}
                  </TableCell>
                  <TableCell align='left'>
                    {t('views.selectFilesModal.type')}
                  </TableCell>
                  <TableCell align='left'>
                    {t('views.selectFilesModal.fileName')}
                  </TableCell>
                  <TableCell align='right'>
                    {t('views.selectFilesModal.createdAtCol')}
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {content.map((file) => (
                  <TableRow hover key={file.id}>
                    <TableCell padding='checkbox'>
                      <Checkbox
                        checked={file.id == selectedFile.id ? true : false}
                        onChange={(event) => {
                          if (event.target.checked) {
                            setSelectedFile({ id: file.id, name: file.name });
                          } else {
                            setSelectedFile({ id: '', name: '' });
                          }
                        }}
                      />
                    </TableCell>
                    <TableCell
                      align='center'
                      sx={{ maxWidth: '5rem', minWidth: '150px' }}
                    >
                      {file.type === 'image' && (
                        <img
                          src={resolveSrc(file?.url)}
                          style={{
                            maxWidth: '110px',
                            height: 'auto',
                            maxHeight: '60px',
                            display: 'block',
                            margin: 'auto',
                          }}
                        />
                      )}
                      {(file.type === 'widget' ||
                        file.type === 'split_screen') && (
                        <img
                          src={`${file.widget?.widgetIcon}`}
                          style={{
                            maxWidth: '110px',
                            height: 'auto',
                            maxHeight: '60px',
                            display: 'block',
                            margin: 'auto',
                          }}
                        />
                      )}

                      {file.type === 'video' && (
                        <video
                          src={resolveSrc(file?.url)}
                          controls={false}
                          autoPlay={false}
                          muted
                          style={{
                            width: '110px',
                            height: 'auto',
                            maxHeight: '60px',
                            margin: 'auto',
                          }}
                        />
                      )}
                      {file.embed === 'embed' && (
                        <embed
                          src={`${file.url}`}
                          style={{
                            maxWidth: '110px',
                            height: 'auto',
                            maxHeight: '60px',
                            margin: 'auto',
                          }}
                        />
                      )}
                    </TableCell>
                    <TableCell align='left'>
                      {file.type === 'image' && (
                        <ImageIcon htmlColor='#6c737f' />
                      )}
                      {file.type === 'widget' && (
                        <AppRegistrationIcon htmlColor='#6c737f' />
                      )}
                      {file.type === 'video' && (
                        <SlowMotionVideoIcon htmlColor='#6c737f' />
                      )}
                      {file.embed === 'embed' && (
                        <AppRegistrationIcon htmlColor='#6c737f' />
                      )}
                      {!(
                        file.type === 'image' ||
                        file.type === 'widget' ||
                        file.type === 'video' ||
                        file.embed === 'embed'
                      ) && <AppRegistrationIcon htmlColor='#6c737f' />}
                    </TableCell>
                    <TableCell sx={{ width: '100%' }}>
                      <Stack alignItems='left' direction='row' spacing={1}>
                        {file.name.length > 30 ? (
                          <p title={file.name}>{file.name.slice(0, 30)}...</p>
                        ) : (
                          <Typography variant='body2'>{file.name}</Typography>
                        )}
                      </Stack>
                    </TableCell>
                    <TableCell>
                      <Typography
                        color='text.secondary'
                        variant='caption'
                        sx={{ display: { md: 'block', xs: 'none' } }}
                        width={180}
                        textAlign='end'
                      >
                        {getNiceTimestamp(new Date(file?.createdAt), true)}
                      </Typography>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'flex-end',
              gap: '10px',
              width: '100%',
              alignItems: 'center',
            }}
          >
            <IconButton
              onClick={() =>
                selectFilesQuery.page > 0 &&
                setSelectFilesQuery({
                  ...selectFilesQuery,
                  page: selectFilesQuery.page - 1,
                  origin: 'page',
                })
              }
            >
              <ArrowBackIosNewIcon />
            </IconButton>
            <Typography>
              {selectFilesQuery.page + 1}/{Math.floor(contentsCount / 30) + 1}
            </Typography>
            <IconButton
              onClick={() =>
                selectFilesQuery.page < Math.floor(contentsCount / 30) &&
                setSelectFilesQuery({
                  ...selectFilesQuery,
                  page: selectFilesQuery.page + 1,
                  origin: 'page',
                })
              }
            >
              <ArrowForwardIosIcon />
            </IconButton>
          </Box>
        </Box>
      </Dialog>
      <YoutubeProcessingDialog
        open={ytPendingNames.length > 0}
        onClose={() => setYtPendingNames([])}
        names={ytPendingNames}
      />
    </>
  );
};

export default SelectFilesModalScheduler;
